import React from 'react'
import MyWalletWrapper from 'src/app/MyWalletWrapper/MyWalletWrapper'
import { AppRoute } from 'src/navigation/appRoutes'
import MyWalletBudgetsPendingAppRoute from 'src/navigation/appRoutes/budgets/budgetsPendingBudgets.appRoute'
import SubmitExpensesAppRoute from 'src/navigation/appRoutes/expenses/submitExpenses.appRoute'
import MyWalletBudgetsAppRoute from 'src/navigation/appRoutes/myWallet/myWalletBudgets.appRoute'
import MyWalletPhysicalCardsAppRoute from 'src/navigation/appRoutes/myWallet/myWalletPhysicalCards.appRoute'
import MyWalletReimbursementAppRoute from 'src/navigation/appRoutes/myWallet/myWalletReimbursement.appRoute'
import MyWalletTransactionsAppRoute from 'src/navigation/appRoutes/myWallet/myWalletTransactions.appRoute'
import MyWalletVirtualCardDetailAppRoute from 'src/navigation/appRoutes/myWallet/myWalletVirtualCardDetail.appRoute'
import MyWalletVirtualCardsAppRoute from 'src/navigation/appRoutes/myWallet/myWalletVirtualCards.appRoute'
import { myWalletRouteProps } from 'src/navigation/routeProps'

const MyWalletAppRoute: AppRoute = {
  routeProps: myWalletRouteProps,
  component: <MyWalletWrapper />,
  subRoutes: [
    MyWalletVirtualCardsAppRoute,
    MyWalletPhysicalCardsAppRoute,
    MyWalletTransactionsAppRoute,
    MyWalletBudgetsAppRoute,
    MyWalletBudgetsPendingAppRoute,
    SubmitExpensesAppRoute,
  ],
  exceptions: [
    MyWalletReimbursementAppRoute,
    MyWalletVirtualCardDetailAppRoute,
  ]
}

export default MyWalletAppRoute
